module.exports = __webpack_public_path__ + "img/header-weddingRingsBlack.ad5fcba.webp";